<template>
  <div class="m-cont">
    <div class="nav-sale">
      <div class="con-sal">
        <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
      </div>
    </div>
    <div class="table-container">
      <h3>Monitoraggio Tempi di Attesa</h3>
      <p>Configura i tempi medi di uscita per portata e il numero di addetti per postazione.</p>
      
      <table class="table table-hover mt-3">
        <thead>
          <tr>
            <th>Categoria</th>
            <th>Minuti</th>
            <th>Secondi</th>
            <th>Addetti Postazione</th>
            <th>Nr. in Parallelo</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="categoria in categorie" :key="categoria">
            <td class="text-capitalize">{{ categoria }}</td>
            <td>
              <input type="number" class="form-control form-control-sm" v-model.number="form[categoria].min" min="0">
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" v-model.number="form[categoria].secondi" min="0" max="59">
            </td>
            <td>
              <input type="number" class="form-control form-control-sm" v-model.number="form[categoria].numero_addetti_postazione" min="0">
            </td>
            <td>
              <input v-if="['primi', 'secondi', 'pizza','trancio','combo','focaccia','teglia','insalate'].includes(categoria)" type="number" class="form-control form-control-sm" v-model.number="form[categoria].numero_in_parallelo" min="1">
            </td>
            <td>
              <button class="btn btn-primary btn-sm" @click="save(categoria)">Salva</button>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div class="mt-4 text-center">
        <button class="btn btn-success" @click="saveAll">Salva Tutto</button>
      </div>
    </div>

    <!-- Notification Toast -->
    <div v-if="notification" class="notification" :class="notification.type">
      {{ notification.message }}
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'TempiDiAttesa',
  data() {
    return {
      store,
      categorie: ['antipasti', 'primi', 'secondi', 'contorni','pizza', 'sushi', 'poke','trancio','combo','focaccia','teglia','insalate'],
      form: {
        antipasti: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        primi: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        secondi: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        contorni: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        pizza: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        sushi: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        poke: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        trancio: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        combo: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        focaccia: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        teglia: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 },
        insalate: { min: 0, secondi: 0, numero_addetti_postazione: 0, numero_in_parallelo: 1 }
      },
      notification: null
    }
  },
  created() {
    this.fetchTempi()
  },
  methods: {
    home() {
      this.$router.push({ name: 'Gestionale' })
    },
    async fetchTempi() {
      try {
        const response = await this.axios.get(this.store.path + 'tempi-di-attesa', {
          headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        })
        if (response.data && response.data.length > 0) {
          response.data.forEach(item => {
            if (this.form[item.categorie_tempi_cucina]) {
              this.form[item.categorie_tempi_cucina] = {
                min: item.min,
                secondi: item.secondi,
                numero_addetti_postazione: item.numero_addetti_postazione,
                numero_in_parallelo: item.numero_in_parallelo || 1
              }
            }
          })
        }
      } catch (error) {
        console.error('Error fetching tempi:', error)
      }
    },
    async save(categoria) {
      try {
        const payload = {
          categorie_tempi_cucina: categoria,
          ...this.form[categoria]
        }
        await this.axios.post(this.store.path + 'tempi-di-attesa', payload, {
          headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        })
        this.notify('Salvataggio completato per ' + categoria, 'success')
      } catch (error) {
        this.notify('Errore durante il salvataggio', 'error')
      }
    },
    async saveAll() {
      try {
        // Sequentially save all categories for simplicity, 
        // or could be a bulk endpoint on backend if preferred.
        for (const cat of this.categorie) {
          await this.save(cat)
        }
        this.notify('Tutti i tempi sono stati aggiornati', 'success')
      } catch (error) {
        this.notify('Si è verificato un errore durante il salvataggio multiplo', 'error')
      }
    },
    notify(message, type) {
      this.notification = { message, type }
      setTimeout(() => {
        this.notification = null
      }, 3000)
    }
  }
}
</script>

<style scoped>
.m-cont {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}
.nav-sale {
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.table-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
.notification {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  border-radius: 4px;
  color: white;
  z-index: 1000;
}
.success { background-color: #28a745; }
.error { background-color: #dc3545; }
</style>
